module.exports = __webpack_public_path__ + "static/media/identidad_card.be86ab57.png";